export { default } from './TextEditor';

export { default as baseConfig } from './baseConfig';
